import axios from 'axios';
import * as Msal from 'msal';
import { userAPI } from './userAPI';
import toast from 'react-hot-toast';

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CUSTOM_AUTH_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_CUSTOM_AUTH_TENANT}`,
    redirectUri: process.env.REACT_APP_CUSTOM_AUTH_REDIRECT_URI
  }
};

const msalInstance = new Msal.UserAgentApplication(msalConfig);

const loginRequest = {
  scopes: [`api://${process.env.REACT_APP_CUSTOM_AUTH_CLIENT_ID}/access_as_user`] // optional Array<string>
};

const loginRequestPbi = {
    scopes: [`https://analysis.windows.net/powerbi/api/.default`] // optional Array<string>
};

export const loginAD = () => (
  new Promise((resolve) => {
    if (msalInstance && msalInstance.getAccount()) {
      msalInstance.acquireTokenSilent(loginRequest)
        .then(async (response) => {
          resolve(response.accessToken);
        })
        .catch((err) => {
          if (err.name === 'InteractionRequiredAuthError') {
            msalInstance.acquireTokenPopup(loginRequest)
              .then((response) => {
                resolve(response.accessToken);
              });
          }
        });
    } else {
      msalInstance.loginRedirect(loginRequest);
    }
  })
);

const base64UrlDecode = (base64Url) => {
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  return decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );
};

const parseJwt = (token) => {
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) {
      throw new Error('Invalid token');
    }
    const base64 = base64UrlDecode(base64Url);
    return JSON.parse(base64);
  } catch (error) {
    console.error('Failed to parse JWT token:', error);
    return null;
  }
};

const loginPBI = () => (
  new Promise((resolve) => {
    if (msalInstance && msalInstance.getAccount()) {
      msalInstance.acquireTokenSilent(loginRequestPbi)
        .then(async (response) => {
          resolve(response.accessToken);
        })
        .catch((err) => {
          if (err.name === 'InteractionRequiredAuthError') {
            msalInstance.acquireTokenPopup(loginRequestPbi)
              .then((response) => {
                resolve(response.accessToken);
              });
          }
        });
    } else {
      msalInstance.loginRedirect(loginRequest);
    }
  })
);

const refreshToken = async () => {
  const newToken = await loginPBI();
  const newDecodedToken = parseJwt(newToken);
  if (newDecodedToken && newDecodedToken.exp) {
    const newTokenExpiry = newDecodedToken.exp * 1000;
    localStorage.setItem('pbiToken', JSON.stringify(newToken));
    localStorage.setItem('pbiTokenExpiry', newTokenExpiry);
  }
};

export const PowerBiAuthentication = async () => {
  const additionalScopeResponse = await loginPBI();

  if (additionalScopeResponse) {
    const decodedToken = parseJwt(additionalScopeResponse);
    if (decodedToken && decodedToken.exp) {
      const tokenExpiry = decodedToken.exp * 1000;

      localStorage.setItem('pbiToken', JSON.stringify(additionalScopeResponse));
      localStorage.setItem('pbiTokenExpiry', tokenExpiry);

      // Periodic token verification for the second token
      setInterval(async () => {
        const currentTokenExpiry = localStorage.getItem('pbiTokenExpiry');
        const currentDateTime = Date.now();
        const timeBuffer = 5 * 60 * 1000;
        if (currentDateTime > currentTokenExpiry - timeBuffer) {
          await refreshToken();
        }
      }, 10 * 60 * 1000); // Check every 10 minutes
    }
  }

  return additionalScopeResponse;
};

class ApiUtils {
  async handleTokenRefresh(props) {
    if (!props.method.includes("Authenticate")) {
      const sessionObjt = JSON.parse(localStorage.getItem("session"));
      if (sessionObjt) {
        const tokenExpiration = parseInt(sessionObjt.accessTokenExpiration, 10);
        const currentTime = Math.round((new Date()).getTime() / 1000);
        if (currentTime >= tokenExpiration) {
          if (process.env.REACT_APP_CUSTOM_AUTH === 'LDAP') {
            // const navigate = useNavigate();
            // navigate('/authentication/login');
            localStorage.removeItem('session');
            window.location.href = '/authentication/login';
            // throw new Error("Not logged in.");
          } else {
            const adResponse = await loginAD();
            localStorage.setItem('session', JSON.stringify({
              accessToken: adResponse
            }));
          }
          const data = await userAPI.AzureAuthenticate();
          if (!data.error && data.value) {
            localStorage.setItem('session', JSON.stringify(data.value));
          } else {
            throw new Error('Erro desconhecido');
          }
        }
      }
    }
  }

  async handleMethod(props) {
    await this.handleTokenRefresh(props);
    const session = JSON.parse(window.localStorage.getItem('session'));
    const availableLanguages = process.env.REACT_APP_AVAILABLE_LANGUAGES.split(';');
    return axios({
      method: props.type,
      url: props.method, // process.env.REACT_APP_WEBAPI_URL + props.method,
      data: props.params,
      timeout: props.timeout ? props.timeout : 60000,
      headers: {
        Authorization: session ? `Bearer ${session.accessToken}` : null,
        'Content-Type': 'application/json;charset=utf-8',
        'Access-Control-Allow-Headers': 'Content-Type, Authorization, Content-Length, X-Requested-With, Accept-Language',
        'Accept-Language': availableLanguages.length > 1 && localStorage.getItem('preferedLanguage') ? localStorage.getItem('preferedLanguage') : availableLanguages[0],
      }
    }).then((response) => {
      if (response && response.status === 200) {
        return response.data;
      }
      return response;
    }).catch((error) => {
      const response = {
        error: true,
        description: error.response?.data?.description || 'Erro desconhecido',
        exceptionMessages: error.response?.data?.exceptionMessages
      };
      return response;
    });
  }

  async handleDownloadMethod(props) {
    await this.handleTokenRefresh(props);
    const session = JSON.parse(window.localStorage.getItem('session'));
    const availableLanguages = process.env.REACT_APP_AVAILABLE_LANGUAGES.split(';');
    return axios({
      method: props.type,
      url: props.method, // process.env.REACT_APP_WEBAPI_URL + props.method,
      data: props.params,
      timeout: props.timeout ? props.timeout : 60000,
      responseType: 'blob',
      headers: {
        Authorization: session ? `Bearer ${session.accessToken}` : null,
        'Content-Type': 'application/json;charset=utf-8',
        'Access-Control-Allow-Headers': 'Content-Type, Authorization, Content-Length, X-Requested-With, Accept-Language',
        'Accept-Language': availableLanguages.length > 1 && localStorage.getItem('preferedLanguage') ? localStorage.getItem('preferedLanguage') : availableLanguages[0],
      }
    }).then((response) => {
      if (response && response.status === 200) {
        return response.data;
      }
      return response;
    }).catch(() => {
      const response = {
        error: true,
        description: 'Erro desconhecido'
      };
      return response;
    });
  }

  async handleFormDataMethod(props) {
    await this.handleTokenRefresh(props);
    const session = JSON.parse(window.localStorage.getItem('session'));
    return axios({
      method: props.type,
      url: props.method, // process.env.REACT_APP_WEBAPI_URL + props.method,
      data: props.params,
      timeout: props.timeout ? props.timeout : 60000,
      headers: {
        Authorization: session ? `Bearer ${session.accessToken}` : null,
        'Content-Type': 'multipart/form-data;charset=utf-8',
        'Access-Control-Allow-Headers': 'Content-Type, Authorization, Content-Length, X-Requested-With'
      }
    }).then((response) => {
      if (response && response.status === 200) {
        return response.data;
      }
      return response;
    }).catch(() => {
      const response = {
        error: true,
        description: 'Erro desconhecido'
      };
      return response;
    });
  }

  async handleError(result) {
    if (result.exceptionMessages && result.exceptionMessages.length > 0) {
      result.exceptionMessages.forEach(m => toast.error(m));
    } else {
      toast.error(result.description || "Erro inesperado");
    }
  }
}

export const apiUtils = new ApiUtils();
